<script lang="ts">
  import { twMerge } from 'tailwind-merge';
  import Button from './Button.svelte';
  import Icon from './Icon.svelte';

  export let href: string | undefined = undefined;
  export let variant: 'default' | 'featured' = 'default';
  export let size: 'md' | 'lg' = 'md';

  let classes = {
    variants: {
      default: 'rounded-full justify-center',
      featured:
        'group rounded gap-x-1.5 md:py-5 md:pr-4 md:pl-6 py-2 pr-1.5 pl-4 leading-tight md:h-[68px]'
    },
    sizes: {
      md: 'px-4 py-3',
      lg: 'px-6 py-4'
    }
  };
</script>

<Button
  variant="outlinePrimary"
  {href}
  {...$$restProps}
  class={twMerge(
    'inline-flex items-center justify-between !text-xxs font-semibold leading-none text-blue ring-1 ring-inset ring-blue transition-colors duration-300 hover:bg-gray-100 hover:text-blue',
    variant === 'default' && classes.variants.default,
    variant === 'default' && classes.sizes[size],
    variant === 'featured' && classes.variants.featured,
    $$restProps.class
  )}
>
  <slot />

  {#if variant === 'featured'}
    <Icon class="shrink-0 duration-200 ease-out group-hover:translate-x-1" name="chevron-right" />
  {/if}
</Button>

<!--
@component
Tag has similar functionality to the Button
## Props
@prop href: string | undefined = undefined;
@prop variant: 'default' | 'featured' = 'default';
@prop size: 'md' | 'lg' = 'md';
-->
